
// * ========================================================================
// * ages per day chart and table
// * ========================================================================

import CovidChart from './covid-chart.js';
import moment from 'moment';
import storage from './../storage';

const sewageArea = (function(){
    const average = (arr) => arr.reduce((a, b) => a + b) / arr.length;

    function createChartData(data, options, selected) {
        const newestValueDate = data.weeks.length ? moment(data.weeks[0].date) : moment('2020-01-01');
        const datasets = [];
        const multiselectOptions = [];
        let latestValue = moment('2019-12-12');

        const averageDatasetOldest = {
            label: '2 viikon keskiarvo (vanhin)',
            name: '2 viikon keskiarvo (vanhin)',
            id: 'always-visible',
            type: 'line',
            fill: false,
            borderColor: '#333333',
            borderWidth: 2,
            pointBorderWidth: 2,
            pointHoverBorderWidth: 2,
            data: [],
            pointRadius: 5,
            pointHoverRadius: 8,
            cubicInterpolationMode: 'default',
            lineTension: 0.2,
            yAxisID: 'y'
        };
        const averageDatasetOld = {
            label: '2 viikon keskiarvo (vanha)',
            name: '2 viikon keskiarvo (vanha)',
            id: 'always-visible',
            type: 'line',
            fill: false,
            borderColor: '#6d3a08',
            borderWidth: 2,
            pointBorderWidth: 2,
            pointHoverBorderWidth: 2,
            data: [],
            pointRadius: 5,
            pointHoverRadius: 8,
            cubicInterpolationMode: 'default',
            lineTension: 0.2,
            yAxisID: 'y'
        };
        const averageDataset = {
            label: '2 viikon keskiarvo',
            name: '2 viikon keskiarvo',
            id: 'always-visible',
            type: 'line',
            fill: false,
            borderColor: '#000000',
            borderWidth: 2,
            data: [],
            pointRadius: 0,
            cubicInterpolationMode: 'default',
            lineTension: 0.2,
            yAxisID: 'y',
            latestValueDate: moment('2019-01-01')
        };

        multiselectOptions.push(averageDataset);

        let datasetIdx = 0;
        Object.values(data.locations).forEach(location => {
            const latestValueDate = moment(location.weeks[0].date);
            if (latestValueDate.isAfter(latestValue)) {
                latestValue = latestValueDate;
            }

            if (latestValueDate >= options.firstDate) {
                const name = location.city + ', ' + location.name;
                const isSelected = selected.indexOf(location.name) !== -1;
                multiselectOptions.push({
                    type: 'bubble',
                    label: name,
                    name: name,
                    id: location.name,
                    backgroundColor: options.largeColorPalette[datasetIdx],
                    fill: true,
                    data: [],
                    barPercentage: 1,
                    borderWidth: 2,
                    pointBorderWidth: 2,
                    pointHoverBorderWidth: 2,
                    pointRadius: 5,
                    pointHoverRadius: 8,
                    selected: isSelected,
                    latestValueDate: latestValueDate
                });

                if (isSelected) { // Only one dataset
                    averageDataset.borderColor = options.largeColorPalette[datasetIdx];

                    // Oldest data
                    datasets.push(averageDatasetOldest);
                    datasets.push({
                        type: 'bubble',
                        label: name + ' (vanhin)',
                        name: name + ' (vanhin)',
                        id: location.name,
                        backgroundColor: '#666666',
                        borderColor: '#333333',
                        fill: true,
                        data: [],
                        barPercentage: 1,
                        selected: true,
                        pointRadius: 5,
                        hoverRadius: 2,
                        borderWidth: 2,
                        yAxisID: 'y'
                    });

                    // Old data
                    datasets.push(averageDatasetOld);
                    datasets.push({
                        type: 'bubble',
                        label: name + ' (vanha)',
                        name: name + ' (vanha)',
                        id: location.name,
                        backgroundColor: '#95571b',
                        borderColor: '#6d3a08',
                        fill: true,
                        data: [],
                        barPercentage: 1,
                        selected: true,
                        pointRadius: 5,
                        hoverRadius: 2,
                        borderWidth: 2,
                        yAxisID: 'y'
                    });

                    // New data
                    datasets.push(averageDataset);
                    datasets.push({
                        type: 'bubble',
                        label: name,
                        name: name,
                        id: location.name,
                        backgroundColor: options.largeColorPalette[datasetIdx],
                        fill: true,
                        data: [],
                        barPercentage: 1,
                        selected: true,
                        pointRadius: 5,
                        hoverRadius: 2,
                        borderWidth: 2,
                        yAxisID: 'y'
                    });

                    const newProcessingDate =moment('2023-01-01').set({
                        hour: 0,
                        minute: 0,
                        second: 0
                    });

                    for (let idx = (location.weeks.length - 1); idx >= 0; idx--) {
                        const item = location.weeks[idx];
                        const date = moment(item.date);

                        // Push only after first visible date
                        if (date >= options.firstDate) {
                            let firstDay = idx + 1;
                            firstDay = firstDay > (location.weeks.length - 1) ? idx : firstDay;

                            const pastWeekValues = [];
                            const pastWeekValuesOld = [];
                            const pastWeekValuesOldest = [];
                            for (let x = idx; x <= firstDay; x++) {
                                if (location.weeks[x].count !== null) {
                                    if (moment(location.weeks[x].date) >= newProcessingDate) {
                                        pastWeekValues.push(location.weeks[x].count);
                                    } else {
                                        pastWeekValuesOld.push(location.weeks[x].count);
                                    }
                                }
                                if (location.weeks[x].countOld !== null) {
                                    pastWeekValuesOldest.push(location.weeks[x].countOldEvened);
                                }
                            }

                            if (date >= newProcessingDate) {
                                let weeksAverage = pastWeekValues.length ? average(pastWeekValues) : 0;
                                weeksAverage = Math.round(weeksAverage);

                                // Add to average count
                                datasets[4].data.push({
                                    x: date,
                                    y: pastWeekValues.length && item.date !== '2022-06-20' ? weeksAverage : NaN
                                });

                                // Add to bubble
                                datasets[5].data.push({
                                    x: date,
                                    y: item.count !== null && item.date !== '2022-06-20' ? item.count : NaN
                                });
                            } else {
                                let weeksAverageOld = pastWeekValuesOld.length ? average(pastWeekValuesOld) : 0;
                                weeksAverageOld = Math.round(weeksAverageOld);

                                // Add to average count
                                datasets[2].data.push({
                                    x: date,
                                    y: pastWeekValuesOld.length && item.date !== '2022-06-20' ? weeksAverageOld : NaN
                                });

                                // Add to bubble
                                datasets[3].data.push({
                                    x: date,
                                    y: item.count !== null && item.date !== '2022-06-20' ? item.count : NaN
                                });
                            }

                            // Old method
                            const weeksAverageOldest = pastWeekValuesOldest.length ? average(pastWeekValuesOldest) : 0;

                            // Add to average count
                            datasets[0].data.push({
                                x: date,
                                y: pastWeekValuesOldest.length ? Math.round(weeksAverageOldest) : NaN
                            });

                            datasets[1].data.push({ // Only one dataset
                                x: date,
                                y: item.countOldEvened !== null ? Math.round(item.countOldEvened) : NaN
                            });
                        }
                    }

                    if (!datasets[0].data.length) {
                        // add last
                    }

                    if (!datasets[5].data.length || datasets[5].data[datasets[5].data.length - 1].x < newestValueDate) {
                        datasets[5].data.push({ // Only one dataset
                            x: newestValueDate,
                            y: NaN
                        });
                    }
                }
                datasetIdx++;
            }
        });

        return { datasets, multiselectOptions, latestValue };
    }

    /**
     * Initialize
     *
     * @param {Object} data - covid data
     */
    function init(data) {

        // Initially selected
        let selected = storage.getData('sewage-area-chart_multiselect');
        if (!selected || !Array.isArray(selected) || !selected.length) {
            selected = ['Viikinmäki']; // Esbå
        }

        // Get data or use old datasets
        let { datasets, multiselectOptions, latestValue } = createChartData(data, window.config, selected);

        // Sort options alphabetically
        multiselectOptions.sort(function(a,b) {
            if (a.latestValueDate.isSame(b.latestValueDate)) {
                return a.name.localeCompare(b.name);
            } else {
                return a.latestValueDate.isAfter(b.latestValueDate) ? 1 : -1;
            }
        });

        const primaryMultiselectOptions = [];
        const secondaryMultiselectOptions = [];
        for (const option of multiselectOptions) {
            if (option.latestValueDate.isSame(latestValue)) {
                primaryMultiselectOptions.push(option);
            } else {
                secondaryMultiselectOptions.push(option);
            }
        }

        const activeYAxis = datasets.length === 0 ? 'y' : datasets.length >= 6 && datasets[5]?.data.length && !isNaN(datasets[5]?.data[0].y) ? datasets[5].yAxisID : datasets[3].yAxisID;

        const chartOptions = {
            datasets,
            chartOptions: {
                type: 'LineWithLine',
                options: {
                    interaction: {
                        mode: 'x',
                        intersect: false
                    },
                    plugins: {
                        tooltip: {
                            intersect: false,
                            position: 'nearest',
                            bodySpacing: 5,
                            callbacks: {
                                label: function(tooltipItem) {
                                    let label = tooltipItem.dataset.label + ': ' || '';
                                    label = label + new Intl.NumberFormat('fi-FI').format(tooltipItem.raw.y);

                                    return label;
                                }
                            },
                        },
                    },
                    scales: {
                        x: {
                            type: 'time',
                            stacked: true,
                            offset: true,
                            time: {
                                unit: 'day',
                                displayFormats: {
                                    day: 'D.M.YY',
                                }
                            }
                        },
                        y: {
                            display: activeYAxis === 'y', // old
                            stacked: false,
                            type: 'linear',
                            position: 'right',
                            ticks: {
                                min: 0
                            },
                            title: {
                                display: true,
                                text: 'Miljoonaa virus-RNA kopiota / 1000 hlö / vrk'
                            }
                        },
                        y2: {
                            display: false, // oldest
                            stacked: false,
                            type: 'linear',
                            position: 'left',
                            ticks: {
                                min: 0
                            },
                            title: {
                                display: true,
                                text: 'Miljoonaa virus-RNA kopiota / 1000 hlö / vrk (vanha)'
                            }
                        },
                        y3: {
                            display: activeYAxis === 'y3', // new
                            stacked: false,
                            type: 'linear',
                            position: 'right',
                            ticks: {
                                min: 0
                            },
                            title: {
                                display: true,
                                text: 'Miljoonaa virus-RNA kopiota / 1000 hlö / vrk'
                            }
                        },
                    }
                }
            },
            config: window.config,
            tooltips: {
                elementId: 'sewage-area-chart-tooltip'
            },
            multiselect: {
                requireCount: false,
                valueType: 'string',
                idField: 'id',
                singleSelect: true,
                closeOnChange: true,
                forceSelectedIds: ['average'],
                colorField: 'backgroundColor',
                inputName: 'sewage-area-chart-multiselect',
                selectElemId: 'sewage-area-chart-multiselect',
                secondarySelectElemId: 'sewage-area-chart-multiselect-old',
                sectionTitleClass: 'sewage-area-chart-multiselect-section-title',
                colorElemId: 'sewage-area-chart-multiselect-colors',
                dropdownId: 'sewage-area-chart-multiselect-dropdown',
                multiselectOptions: primaryMultiselectOptions,
                secondaryMultiselectOptions: secondaryMultiselectOptions,
                data: data,
                reloadOnChange: reload
            },
            responsive: ['aspectRatio']
        };

        window.sewageAreaChart = new CovidChart('sewage-area-chart', chartOptions);
    }

    function reload(data = null) {
        if (window.sewageAreaChart) {
            window.sewageAreaChart.chart.destroy();
            delete window.sewageAreaChart;

            // For some reason, chart wont go away sometimes

            // remove all content
            const chartContainer = document.querySelector('.sewage-area-chart .chart-container');
            chartContainer.innerHTML = '';

            // Remove multiselects
            const multiSelectContainers = document.querySelectorAll('.sewage-area-chart .multiselect');
            multiSelectContainers.forEach((elem) => {
                elem.innerHTML = '';
            });

            // Re create tooltip elem for same reason
            const tooltip = document.createElement('div');
            tooltip.classList.add('chart-tooltip');
            tooltip.id = 'sewage-area-chart-tooltip';

            // Re-create canvas
            const canvasEl = document.createElement('canvas');
            canvasEl.id = 'sewage-area-chart';
            canvasEl.width = 888;
            canvasEl.height= 440;

            chartContainer.appendChild(canvasEl);
            chartContainer.appendChild(tooltip);
        }

        init(data);
    }

    return {
        init,
        reload
    }

})();

export default sewageArea;
